import React from 'react'
import PropTypes from 'prop-types'
import { ButtonIcon, CollapsibleBlock, Columns, CounterBadge, LocalizedText, UndoIcon } from 'src/components'
import { useHandler } from 'src/hooks'
import { TableContext } from 'src/contexts'
import styles from './FiltersArea.scss'

/**
 * A Table component with a CollapsibleBlock of FilterTable above.
 */
const FiltersArea = ({ children }) => {
  const { filters } = TableContext.use()

  // get filters count
  const count = React.useMemo(() => Object.keys(filters).filter(key => filters[key].count).length, [filters])

  // reset filters
  const onReset = useHandler(
    e =>
      e.stopPropagation() ||
      Object.keys(filters)
        .map(key => filters[key].reset)
        .forEach(reset => reset && reset())
  )

  return (
    <CollapsibleBlock
      title={
        <CounterBadge inline count={count} color="secondary">
          <LocalizedText id="WEB_FILTER_DISPLAY" />
        </CounterBadge>
      }
      className={styles.container}
      defaultCollapsed={true}
      toolbar={
        <ButtonIcon disabled={!count} icon={UndoIcon} onClick={onReset}>
          <LocalizedText id="WEB_FILTER_RESET_ALL" />
        </ButtonIcon>
      }
    >
      <Columns gap="1rem" layout="1" className={styles.filters}>
        {children}
      </Columns>
    </CollapsibleBlock>
  )
}

FiltersArea.propTypes = {
  children: PropTypes.node,
}

export default FiltersArea
